import palette from '../palette';

const MuiButtonBase = {
  styleOverrides: {
    root: {
      '&.MuiCheckbox-root': {
        padding: 8,
      },
      '&.MuiLoadingButton-root': {
        borderColor: palette.secondary.main,
        color: palette.secondary.light,
      },
      '&.MuiLoadingButton-root.Mui-selected': {
        borderColor: palette.secondary.main,
        color: palette.secondary.light,
      },
      '&.MuiLoadingButton-root.Mui-selected:hover': {
        backgroundColor: palette.secondary.dark,
        color: palette.secondary.light,
      },
      '&.MuiToggleButton-root': {
        borderColor: palette.secondary.main,
        color: palette.secondary.main,
      },
      '&.MuiToggleButton-root.Mui-selected': {
        backgroundColor: palette.secondary.main,
        color: palette.secondary.light,
      },
      '&.MuiToggleButton-root.Mui-selected:hover': {
        backgroundColor: palette.secondary.dark,
        color: palette.secondary.light,
      },
    },
  },
};

export default MuiButtonBase;
